import { Box, HTMLWrapper, Stack } from "@/storybook-components";
import type { Question } from "@/types";
import { surveyParticipantFieldSection } from "./survey-participant-test-ids";

interface SectionQuestionProps {
  question: Question;
  participantFieldId: string;
}

const SectionQuestion = ({
  question,
  participantFieldId
}: SectionQuestionProps): JSX.Element => {
  return (
    <Stack
      gap={1}
      data-testid={surveyParticipantFieldSection(participantFieldId)}
    >
      <HTMLWrapper
        html={question.question}
        className="ehq-surveyQuestionHeading"
        fontSize="1.5rem"
        lineHeight="123.5%"
        fontWeight="bold"
        color="gray.800"
      />
      <Box className="ehq-sectionQuestion">
        <HTMLWrapper html={question.descriptor} />
      </Box>
    </Stack>
  );
};

export default SectionQuestion;
